<template>
  <div class="settle-accounts-info">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-overflow
        show-footer
        :footer-method="footerMethod"
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <!-- :checkbox-config="{ checkMethod: activeRowMethod }" -->
        <template v-slot:buttons v-if="isCreate">
          <!-- <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新增行</el-button
          > -->
          <el-button
            @click="introductionFeeHandler"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >引入费用</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <!-- <span
              v-if="
                ['periodDateFrom', 'periodDateUntil', 'unloadingDate'].includes(
                  item?.editRender?.name
                ) && row[item.field]
              "
              >{{ formatDateStr(row[item.field], true) }}</span
            > -->
            <!-- <span v-else-if="item.editRender.name == 'expenseType'">{{
              row['expenseTypeLabel']
            }}</span> -->
            <span v-if="item.editRender.name == 'expenseType'">{{
              expenseType?.find((item) => item.value == row['expenseType'])?.label
            }}</span>
            <span v-else-if="item.editRender.name == 'productCode'">{{
              productList?.find((item) => item.value == row['productCode'])?.label
            }}</span>
            <span v-else-if="item.editRender.name == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span>
            <!-- <span v-else-if="item.editRender.name == 'settlementQuantity'">{{
              row[item.field] | formateQuantityToWumao(isWuMaoAccount)
            }}</span> -->
            <template v-else-if="['settlementQuantity'].includes(item.field)">{{
              replaceLastZeroStr(row[item.field])
            }}</template>
            <template v-else-if="['domesticTaxAmount'].includes(item.field)">{{
              $utils.commafy($utils.toNumber(replaceLastZeroStr(row[item.field])), { digits: 2 })
            }}</template>
            <template v-else-if="item.field == 'originalPrice'">
              {{ replaceZeroStr(row[item.field]) }}
            </template>
            <template
              v-else-if="
                [
                  'originalAmount',
                  'originalAmountWithoutTax',
                  'originalTaxAmount',
                  'domesticAmount',
                  'domesticAmountWithoutTax',
                ].includes(item.field)
              "
              >{{
                $utils.commafy($utils.toNumber(replaceZeroStr(row[item.field])), { digits: 2 })
              }}</template
            >
            <!-- <el-select
              v-else-if="item.editRender.name == 'expenseType'"
              filterable
              clearable
              disabled
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of expenseType"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select> -->
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 费用编号 -->
            <el-input
              v-if="item.editRender.name == 'expenseNo'"
              v-model="row[item.field]"
              maxlength="20"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 费用类型 -->
            <el-select
              v-if="item.editRender.name == 'expenseType'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of expenseType"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>

            <!-- 原币结算单价(含税) -->
            <el-input-number
              :precision="8"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'originalPrice'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 原币结算金额（不含税） -->
            <input-number-ad
              :precision="2"
              :min="null"
              :max="999999999"
              :controls="false"
              v-if="item.editRender.name == 'originalAmountWithoutTax'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></input-number-ad>
            <!-- 结算数量 -->
            <el-input-number
              :precision="isWuMaoAccount ? 8 : 4"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'settlementQuantity'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 计量单位 -->
            <!-- <el-input
              v-if="item.editRender.name == 'unit'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input> -->
            <el-select
              v-if="item.editRender.name == 'unit'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of basic_unit"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
            <!-- 原币结算金额(含税) -->
            <el-input-number
              :precision="2"
              :controls="false"
              :min="null"
              v-if="item.editRender.name == 'originalAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 币种 -->
            <el-select
              v-if="item.editRender.name == 'currencyCode'"
              filterable
              clearable
              disabled
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) in currencyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 汇率 -->
            <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'exchangeRate'"
              disabled
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 本币结算金额（含税） -->
            <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'domesticAmount'"
              v-model="row[item.field]"
              disabled
              @input="() => handleChange(row, item.field)"
            ></el-input-number>

            <!-- 业务账期日期从 -->
            <el-date-picker
              v-model="row[item.field]"
              v-if="item.editRender.name == 'periodDateFrom'"
              :controls="false"
              :clearable="true"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              @blur="() => handleChange(row, item.field)"
            ></el-date-picker>
            <!-- 业务账期日期至 -->
            <el-date-picker
              v-model="row[item.field]"
              v-if="item.editRender.name == 'periodDateUntil'"
              :controls="false"
              :clearable="true"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              @blur="() => handleChange(row, item.field)"
            ></el-date-picker>
            <!-- 业务单据编号 -->
            <el-input
              v-if="item.editRender.name == 'businessDocNo'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input>

            <!-- 发货日期 -->
            <el-date-picker
              v-model="row[item.field]"
              v-if="item.editRender.name == 'deliveryDate'"
              :controls="false"
              :clearable="true"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
            <!-- 卸货日期 -->
            <!-- <el-date-picker
              v-model="row[item.field]"
              v-if="item.editRender.name == 'unloadingDate'"
              :controls="false"
              :clearable="true"
              style="width: 100%"
            ></el-date-picker> -->
            <!-- 税率 -->
            <el-input-number
              :precision="2"
              :controls="false"
              :min="0"
              v-if="item.editRender.name == 'taxRate'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 商品名称 -->
            <!-- <el-input
              v-if="item.editRender.name == 'productCode'"
              v-model="row[item.field]"
              maxlength="20"
              @input="() => handleChange(row, item.field)"
            ></el-input> -->
            <el-select
              v-if="item.editRender.name == 'productCode'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of productList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
            <!-- 商品类别-->
            <el-input
              v-if="item.editRender.name == 'goodsCategoryName'"
              v-model="row[item.field]"
              maxlength="20"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 商品规格-->
            <el-input
              v-if="item.editRender.name == 'productModel'"
              v-model="row[item.field]"
              :disabled="true"
              maxlength="20"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              @input="(e) => handleChange(row, item.field)"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <IntroductionCostDialog ref="IntroductionCostDialog" @confirmHandler="confirmHandler" />
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  import IntroductionCostDialog from '../IntroductionCostDialog/index.vue';
  import BASEAPI from '@/api/dataBase.js';
  export default {
    components: {
      IntroductionCostDialog,
    },
    name: 'SettleAccountsInfo',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      // 商品
      productList: {
        type: Array,
        default: () => [],
      },
      // 所有明细行
      lineDetailsList: {
        type: Array,
        default: () => [],
      },
      currentSettleAccountRowData: {
        type: Object,
        require: true,
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        currencyList: [],
        tableRules,
        tableColumnList,
        deleteLineDetailIds: [], //删除明细行的ids
      };
    },

    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }
            if (['domesticAmount'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }
            return null;
          }),
        ];
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          // console.log(item[field], '+item[field]00000000000');
          count += +item[field];
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      //是否可以编辑
      activeRowMethod({ columnIndex }) {
        if (['create'].includes(this.$route.query?.status)) {
          if (this.$route.query?.id) {
            if (
              columnIndex == 18 ||
              columnIndex == 4 ||
              columnIndex == 5 ||
              columnIndex == 7 ||
              columnIndex == 8 ||
              columnIndex == 20 ||
              columnIndex == 24
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            // if (
            //   columnIndex == 18 ||
            //   columnIndex == 4 ||
            //   columnIndex == 5 ||
            //   columnIndex == 20 ||
            //   columnIndex == 24
            // ) {
            //   return true;
            // } else {
            //   return false;
            // }
            return true;
          }
        } else {
          return this.isCreate;
        }
      },
      //校验
      async validAllEvent() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
        this.$emit('saveDeleteLineDetailIds', this.deleteLineDetailIds);
        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      // 新增行
      async newRowHandler() {
        const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        // 先获取表单中的币种和汇率
        const $table = this.$refs.settleAccountsRef;
        const rowData = { currencyCode, currencyName, exchangeRate };
        $table.setRadioRow(rowData);
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      introductionFeeHandler() {
        this.$emit('_formatSettleAccountDto');
        const { currencyCode, currencyName, exchangeRate, contractNo } = this.baseFormData;
        const { productCode, productName } = this.currentSettleAccountRowData;

        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        if (!productCode) {
          this.$message.error('请补充结算行数据');
          return;
        }
        setTimeout(() => {
          this.$refs.IntroductionCostDialog.lineDetailsList = this.lineDetailsList;
          this.$refs.IntroductionCostDialog.query.contractNo = contractNo;
          this.$refs.IntroductionCostDialog.query.productCode = productCode;
          this.$refs.IntroductionCostDialog.query.productName = productName;
          this.$refs.IntroductionCostDialog.openModal();
        }, 50);
      },
      confirmHandler(val) {
        this.$emit('importData', val);
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const xIDList = this.selectionList.map((item) => item._XID);
        let deleteIds = this.selectionList.map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
        this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
        this.$emit('deleteTableHandler', xIDList);
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '修改');
        if (field === 'currencyCode') {
          row['currencyName'] = this.currencyList?.find(
            (item) => item.value == row['currencyCode']
          )?.label;
        } else if (field === 'originalAmount') {
          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;
          row['originalPrice'] =
            (row['originalAmount'] / row['settlementQuantity']).toFixed(8) || 0;
          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'taxRate') {
          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'periodDateFrom') {
          if (row['periodDateUntil'] !== null) {
            if (
              new Date(row['periodDateFrom']).getTime() > new Date(row['periodDateUntil']).getTime()
            ) {
              this.$message.error('开始时间不能大于结束时间');
              row['periodDateFrom'] = null;
            }
          }
        } else if (field === 'periodDateUntil') {
          if (row['periodDateFrom'] !== null) {
            if (
              new Date(row['periodDateFrom']).getTime() > new Date(row['periodDateUntil']).getTime()
            ) {
              this.$message.error('结束时间不能小于开始时间');
              row['periodDateUntil'] = null;
            }
          }
        } else if (field === 'originalPrice') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
          // console.log(lineDetails, 'lineDetails999999999');
        } else if (field === 'settlementQuantity') {
          row['settlementQuantity'] = this.isWuMaoAccount
            ? row['settlementQuantity'].toFixed(8)
            : row['settlementQuantity'].toFixed(4);
          row['originalAmount'] =
            +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;

          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'productCode') {
          row['productName'] = this.productList?.find(
            (item) => item.value == row['productCode']
          )?.label;

          row['taxRate'] = this.productList?.find(
            (item) => item.value == row['productCode']
          )?.taxRate;

          row['productModel'] = this.productList?.find(
            (item) => item.value == row['productCode']
          )?.productModel;

          row['contractDetailId'] = this.productList?.find(
            (item) => item.value == row['productCode']
          )?.contractDetailId;

          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        } else if (field === 'unit') {
          row['unitName'] = this.basic_unit?.find((item) => item.value == row['unit'])?.label;
        } else if (field === 'originalAmountWithoutTax') {
          row['domesticAmountWithoutTax'] = row['originalAmountWithoutTax'];

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticTaxAmount'] = row['originalTaxAmount'];
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
          const tableData = this.getTableData().map((item) => {
            return {
              ...item,
              currencyCode,
              currencyName,
              exchangeRate,
            };
          });
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          await $table.clearActived();
        }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {
      expenseType() {
        return this.dictListMap?.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          console.log(val, '子组件');
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.getCurrencyList();
    },
  };
</script>

<style lang="scss" scoped>
  .settle-accounts-info {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
